import script from "./middle1.vue?vue&type=script&setup=true&lang=js"
export * from "./middle1.vue?vue&type=script&setup=true&lang=js"

import "./middle1.vue?vue&type=style&index=0&id=304b7db0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-304b7db0"]])

export default __exports__